<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>

                        <v-toolbar card prominent dense>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.lgAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        @click="loadContracts"
                                    >
                                        <v-icon>mdi-reload</v-icon> <template v-if="$vuetify.breakpoint.lgAndUp">{{ $t("reload") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("reload") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!acl.Create || $store.getters.subscription.settings.contracts.lock"
                                        @click="addContractClick"
                                    >
                                        <v-icon>mdi-plus-circle-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("create") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("create") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Modify || $store.getters.subscription.settings.contracts.lock"
                                        @click="editContractClick(selectedRow)"
                                    >
                                        <v-icon>mdi-pencil-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("edit") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("edit") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="$vuetify.breakpoint.mdAndUp"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Delete || $store.getters.subscription.settings.contracts.lock"
                                        @click="deleteItemClick(selectedRow)"
                                    >
                                        <v-icon>mdi-delete-outline</v-icon> <template v-if="$vuetify.breakpoint.mdAndUp">{{ $t("delete") }}</template>
                                    </v-btn>
                                </template>
                                <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-card-text class="v-scrollable lengths-table">
                            <v-data-table
                                hide-actions
                                :headers="computedHeaders"
                                :items="contracts"
                                :search="contractsSearch"
                                @dblclick:row="editLengthClick(selectedRow)"
                                class="dense-table"
                            >
                                <template v-slot:items="props">
                                    <tr
                                        @click="selectedRow = props.item"
                                        @dblclick:row="editLengthClick(props.item)"
                                        :class="{'grey darken-5': props.item === selectedRow}"
                                    >
                                        <td class="text-xs-center font-weight-bold"><v-icon small class="mr-1">mdi-invoice-list-outline</v-icon> {{ props.item.Num }} </td>
                                        <td class="text-xs-left">{{ props.item.Name }}</td>
                                        <td class="text-xs-left">{{ props.item.modDate }}</td>
                                    </tr>
                                </template>
                                <!--
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" icon="warning">
                                        {{ $t("youSearchFor") }}{{ lengthsSearch }}{{ $t("foundNoResults") }}.
                                    </v-alert>
                                </template>
                                -->
                            </v-data-table>
                        </v-card-text>
            </v-card>

            <message-box        ref="MessageBox"/>
            <message-dialog     ref="MessageDialog"/>
            <edit-contract-dialog  ref="EditContractDialog"/>
        </v-flex>
        <v-alert
            :value="dataSavedAlert"
            type="success"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ $t("dataSaved") }}
        </v-alert>
         <v-alert
            :value="alert !== ''"
            type="success"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import MessageBox           from "@/components/dialogs/MessageBox";
    import MessageDialog        from "@/components/dialogs/MessageDialog";
    import EditContractDialog   from "@/components/dialogs/EditContractDialog.vue";

    export default {
        name: "ContractsManagement",

        components: {
            MessageBox,
            MessageDialog,
            EditContractDialog,
        },

        data () {
            return {
                alert:         "",
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                breadCrumbs: [
                    { text: "Справочники", disabled: false },
                    { text: "Заказы",       disabled: false }
                ],
                headers: [
                    { text: "id",       value: "id",     align: "center", sortable: true },
                    { text: "Номер",    value: "num",    align: "center", sortable: true, width: "80px" },
                    { text: "Длина, м", value: "len",    align: "left",   sortable: true },

                ],


                loading: {
                    contracts:  false,
                },

                hideIDs: true,
                contracts: [],
                contractsSearch: "",
                lengthsSearch: "",
                lengthsUpdated: false,
                lengthWatcher: null,
                progressBarVisible: false,
                selectedRow: null,
                dataSavedAlert: false,
                duplicateAlert: false,
                dialogWatcher: null,

            }

        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                }

                return this.headers;
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            duplicateAlert: function (val) {
                if (val) {
                    setTimeout(() => this.duplicateAlert = false, 1500);
                }
            },

            dataSavedAlert: function (val) {
                if (val) {
                    setTimeout(() => this.dataSavedAlert = false, 1500);
                }
            },

        },

        mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();
            this.loadContracts();

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "contracts") {
                        this.acl = aclRecord;
                    }
                });
            }

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",                        value: "id",      align: "center", sortable: true },
                    { text: this.$t("contractNumber"),   value: "num",     align: "center", sortable: true, width: "80px" },
                    { text: this.$t("name"),             value: "name",    align: "left",   sortable: true },
                    { text: this.$t("createModifyDate"), value: "modDate", align: "left",   sortable: true }
                ];

                this.breadCrumbs = [
                    { text: this.$t("catalogs"),  disabled: false },
                    { text: this.$t("contracts"), disabled: false }
                ];
            },

            /**
             * Обработчик нажатия кнопки добавления новых заказов
             */
             addContractClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.EditContractDialog.saveData",
                    (val) => {
                        if (val) {
                            this.axios({
                                method: "post",
                                url: `${this.$config.apiURL}contracts/`,
                                data: {
                                    Num:  this.$refs.EditContractDialog.contractNum,
                                    Name: this.$refs.EditContractDialog.contractName
                                },
                                withCredentials: true
                            }).then(() => {
                                this.dataSavedAlert = true;
                                //this.dataUpdated    = true;
                                this.loadContracts();
                            }).catch(error => {
                                if (error.response && error.response.status == 401) {
                                    this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                    // Удаление наблюдателя если установлен
                                    if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                    // Отслеживание нажатия кнопки ok в диалоге
                                    this.dialogWatcher = this.$watch(
                                        "$refs.MessageBox.dialog",
                                        () => { window.location.reload(); }
                                    );
                                } else if (error.response && error.response.status == 402) {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateContract") + ". " + this.$t("subscriptionExpired"));

                                    // Удаление наблюдателя если установлен
                                    if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                    // Отслеживание нажатия кнопки ok в диалоге
                                    this.dialogWatcher = this.$watch(
                                        "$refs.MessageBox.dialog",
                                        () => { this.$emit("doLogout", true); }
                                    );
                                } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                    this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                } else if (error.response && error.response.status == 403) {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateContract") + ". " + this.$t("accessDenied"));
                                } else {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateContract"));
                                }
                            });
                        }
                    }
                );

                this.$refs.EditContractDialog.resetForm();
                this.$refs.EditContractDialog.saveData = false;
                this.$refs.EditContractDialog.dialog   = true;
            },

            /**
             * Удаление элемента
             *
             * @param {object} item Информация об удаляемом элементе
             */
            deleteItem (item) {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}contracts/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.loadContracts();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteContract") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteContract") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteContract"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления длины
             *
             * @param {object} item Информация об удаляемом элементе
             */
            deleteItemClick (item) {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("ContractDelete");
                this.$refs.MessageDialog.messageText = `${this.$t("confirmContractDelete")} (${item.Name})`;
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Обработчик нажатия кнопки изменения значения длины
             *
             * @param {object} Информация о длине
             */
            editContractClick (item) {
                //this.$debug.log(item);
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.EditContractDialog.saveData",
                    (val) => {
                        if (val) {
                            this.axios({
                                method: "patch",
                                url: `${this.$config.apiURL}contracts/${item.id}/`,
                                data: {
                                    Num: this.$refs.EditContractDialog.contractNum,
                                    Name: this.$refs.EditContractDialog.contractName
                                },
                                withCredentials: true
                            }).then(() => {
                                this.dataSavedAlert = true;
                                //this.dataUpdated    = true;
                                this.loadContracts();
                            }).catch(error => {
                                if (error.response && error.response.status == 401) {
                                    this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                                    // Удаление наблюдателя если установлен
                                    if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                    // Отслеживание нажатия кнопки ok в диалоге
                                    this.dialogWatcher = this.$watch(
                                        "$refs.MessageBox.dialog",
                                        () => { window.location.reload(); }
                                    );
                                } else if (error.response && error.response.status == 402) {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateContract") + ". " + this.$t("subscriptionExpired"));

                                    // Удаление наблюдателя если установлен
                                    if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                    // Отслеживание нажатия кнопки ok в диалоге
                                    this.dialogWatcher = this.$watch(
                                        "$refs.MessageBox.dialog",
                                        () => { this.$emit("doLogout", true); }
                                    );
                                } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                    this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                } else if (error.response && error.response.status == 403) {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateContract") + ". " + this.$t("accessDenied"));
                                } else {
                                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateContract"));
                                }
                            });
                        }
                    }
                );

                this.$refs.EditContractDialog.resetForm();
                this.$refs.EditContractDialog.contractNum = item.Num;
                this.$refs.EditContractDialog.contractName = item.Name;
                this.$refs.EditContractDialog.saveData  = false;
                this.$refs.EditContractDialog.dialog  = true;

            },

            /**
             * Загрузка
             */
            loadContracts () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}contracts/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {

                            this.contracts = response.data.contracts;

                            this.contracts.forEach((contract) => {
                                contract.modDate = new Date(contract.updatedAt);
                                contract.modDate = `${contract.modDate.toLocaleDateString()} ${contract.modDate.toLocaleTimeString()}`
                            })
                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadContractsData"));
                        }
                    });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 150px)
</style>
